
  import { defineComponent } from 'vue';

  import PageTitle from '@/common/components/redesigned/PageTitle.vue';
  import Constants from '@/common/constants';
  import security from '@/common/mixins/security';

  import keyCountryIndicatorApi from '../api/keyCountryIndicator';
  import KeyCountryIndicatorForm from '../components/key-country-indicator/KeyCountryIndicatorForm.vue';
  import { TKeyCountryIndicatorSave } from '../types/keyCountryIndicator';

  const PERMISSIONS = {
    create: Constants.Permissions.KeyCountryIndicatorCreate,
  };

  export default defineComponent({
    name: 'KeyCountryIndicatorAdd',
    components: {
      PageTitle,
      KeyCountryIndicatorForm,
    },
    mixins: [security],
    data(): { isLoading: boolean } {
      return {
        isLoading: false,
      };
    },
    created() {
      this.checkPermissionAndRedirect(PERMISSIONS.create);
    },
    methods: {
      async save({ item, onSuccess, onError }: TKeyCountryIndicatorSave) {
        try {
          this.isLoading = true;
          await keyCountryIndicatorApi.create(item);
          onSuccess();
        } catch {
          onError();
        } finally {
          this.isLoading = false;
        }
      },
    },
  });
